import { groupBy } from 'utils/groupBy';

type SubscriptionEvent = {
  start: number;
  end: number;
  address: string;
  amount: number;
};

export function transformSubEvents(events: SubscriptionEvent[]) {
  const generated: { [key: string]: SubscriptionEvent[] } = {};

  const eventTimestamps = events.map((e) => [e.start, e.end]).flat();
  // @ts-ignore
  const uniqueEventTimestamps = [...new Set(eventTimestamps)].sort(
    (a, b) => a - b
  );

  uniqueEventTimestamps.forEach((ts, tsIdx) => {
    events.forEach((e, idx) => {
      if (e.start === ts || (e.start < ts && e.end > ts)) {
        const startTs = e.start;
        const endTs = uniqueEventTimestamps[tsIdx + 1];

        if (generated[startTs]) {
          generated[startTs].push({
            ...e,
            start: startTs,
            end: endTs
          });
        } else {
          generated[startTs] = [{ ...e, start: startTs, end: endTs }];
        }

        if (e.end !== endTs) {
          events.splice(idx, 1, { ...e, start: endTs });
        }
      }
    });
  });

  // Map through generated
  const result = Object.keys(generated).map((key) => {
    const grouped = groupBy(generated[key], 'address');
    const groupedSummed = grouped.map((g) =>
      g.reduce(
        (prev: SubscriptionEvent, curr: SubscriptionEvent) => ({
          start: curr.start,
          end: curr.end,
          address: curr.address,
          amount: (prev.amount || 0) + curr.amount
        }),
        {} as SubscriptionEvent
      )
    );

    const sorted = groupedSummed.sort((a, b) => b.amount - a.amount);
    return {
      address: sorted[0].address,
      amount: sorted[0].amount,
      duration: sorted[0].end - sorted[0].start
    };
  });

  return result;
}
